module.exports = __webpack_public_path__ + "img/icon4.f4d98dbd.png";